import {Injectable} from '@angular/core';

@Injectable()
export class DataStorageService<T = any> {
    private data: {[key: string]: T} = {};

    /**
     * Установить значение.
     * Переписывает значение, если есть.
     * @param {string} key
     * @param data
     */
    set(key: string|number, data: T) {
        this.data[key] = data;
    }

    /**
     * Добавить значение, если его нет.
     * @param {string} key
     * @param data
     */
    add(key: string, data: T) {
        if (!this.data.hasOwnProperty(key)) {
            this.data[key] = data;
        }
    }

    /**
     * Получить значение по ключу
     * @param {string} key
     * @returns {any}
     */
    get(key: string|number): T {
        return this.data[key];
    }

    /**
     * Получить все значения
     */
    getAll(): T[] {
        return Object.keys(this.data).map(key => this.data[key]);
    }

    /**
     * Удалить значение
     * @param {string} key
     */
    remove(key: string): void {
        delete this.data[key];
    }

    /**
     * Проверить наличие
     * @param {string} key
     * @returns {boolean}
     */
    has(key: string): boolean {
        return this.data.hasOwnProperty(key);
    }
}

